import { Attrs, MinzeElement } from 'minze'

export interface LvcInfoIcon {
  dataWidth: number
  dataHeight: number
}

export class LvcInfoIcon extends MinzeElement {
  attrs: Attrs = [
    ['data-width', 16],
    ['data-height', 16],
  ]

  html = () => `
    <svg width="${this.dataWidth}" height="${this.dataHeight}" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="16" height="16" rx="8" fill="#FF4600"/>
      <path d="M8.14075 5.83884C7.86598 5.83884 7.64053 5.75429 7.4644 5.5852C7.28826 5.40907 7.2002 5.18714 7.2002 4.91942C7.2002 4.6517 7.28826 4.43329 7.4644 4.2642C7.64053 4.08807 7.86598 4 8.14075 4C8.41552 4 8.64097 4.08807 8.8171 4.2642C8.99324 4.43329 9.08131 4.6517 9.08131 4.91942C9.08131 5.18714 8.99324 5.40907 8.8171 5.5852C8.64097 5.75429 8.41552 5.83884 8.14075 5.83884ZM7.35872 6.58917H8.92278V12H7.35872V6.58917Z" fill="white"/>
    </svg>
  `

  css = () => `
    
  `
}
